import React from 'react'
import {IAuthService} from '@base/features/auth/model/interfaces';
import {useBehaviorSubject} from '../helpers';
import { container } from 'tsyringe';

export default function useSession() {
  const authService: IAuthService = container.resolve('authService');
  const currentUser = useBehaviorSubject(authService.userSession);
  return currentUser;
}
